import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogTitle, MatDialogModule } from '@angular/material/dialog';
import { Co } from '../../interfaces/co.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';
import { TruncatePipe } from '../../pipes/truncate.pipe';
import { RouterLink } from '@angular/router';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';
import { NgClass, UpperCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css'],
    standalone: true,
    imports: [MatDialogModule, MatButton, MatIconModule, NgClass, MatDivider, RouterLink, UpperCasePipe, TruncatePipe]
})
export class ConfirmDialogComponent implements OnInit {

  dialogId: string = '';
  combinedItems: { name: string; code: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private coreService: CoreService,
  ) {}

  ngOnInit(): void {
    this.dialogId = this.coreService.dialogId;

    // Combina los arrays fileNames y errorCodes en combinedItems si están definidos
    this.combinedItems = this.data?.fileNames?.map((fileName: string, index: number) => ({
      name: fileName,
      code: this.data.errorCodes?.[index],
    })) || [];
  }



  onNoClick(): void {
    this.dialogRef.disableClose = true;
    this.dialogRef.addPanelClass('scale-out-center');

    setTimeout(() => {
      this.dialogRef.close(false);
    }, 300);
  }

  onConfirm(): void {
    this.dialogRef.disableClose = true;
    this.dialogRef.addPanelClass('scale-out-center');

    setTimeout(() => {
      this.dialogRef.close(true);
    }, 300);
  }

  closeDialog(): void {
    this.dialogRef.disableClose = true;
    this.dialogRef.addPanelClass('scale-out-center');

    setTimeout(() => {
      this.dialogRef.close();
    }, 300);
  }

}
